import { render } from "./SiteAnnouncement.vue?vue&type=template&id=588144a0&scoped=true"
import script from "./SiteAnnouncement.vue?vue&type=script&lang=js"
export * from "./SiteAnnouncement.vue?vue&type=script&lang=js"

import "./SiteAnnouncement.vue?vue&type=style&index=0&id=588144a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588144a0"]])

export default __exports__